import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CrudService } from './crud.service';

@Injectable({
  providedIn: 'root',
})
export class ProjectService extends CrudService {

  constructor(public override http: HttpClient) {
    super('project', http);
  }

  /**
   * Check project field is unique
   * @returns object
   */
  checkUniqueProject(projectName: string, id: number) {
    return this.http.get(
      `${this.baseUrl}/check-unique-project/${projectName}/${id}`
    );
  }

}
